import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { LogoTile } from "../components/Logo";

const AuthCallback = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
        const exchange = async () => {
            try {
                const { data } = await api.post("/auth/google/session", { session_id: sessionId });
                window.history.replaceState(null, "", window.location.pathname);
                navigate("/settings", { state: { user: data.user }, replace: true });
            } catch (e) {
                const detail = e?.response?.data?.detail;
                navigate("/login", {
                    state: { error: typeof detail === "string" ? detail : "Google sign-in failed. Please try again." },
                    replace: true,
                });
            }
        };
        exchange();
    }, [location, navigate]);

    return (
        <div className="flex min-h-screen items-center justify-center bg-[#F5F2EA]" data-testid="auth-callback-loading">
            <div className="animate-pulse">
                <LogoTile size={52} />
            </div>
        </div>
    );
};

export default AuthCallback;
